import { withCdnUrl } from "@smile2impress/attraction-utils";
import { TFunction } from "next-i18next";

import { UrlsConfig } from "configs/urlsConfig";

import { ErrorPageContentProps } from "./types";

const image = {
    images: [
        {
            jpeg: withCdnUrl("/images/error/error_404_mobile.jpg"),
        },
        {
            jpeg: withCdnUrl("/images/error/error_404_desktop.jpg"),
        },
    ],
    aspectRatio: ["1/1"],
    defaultSrc: withCdnUrl("/images/error/error_404_mobile.jpg"),
};

const pageContent = (t: TFunction): ErrorPageContentProps => {
    return {
        api: {
            title: t("error:apiErrorTitle"),
            subtitle: t("error:apiErrorSubtitle"),
            button: {
                text: t("error:apiErrorAction"),
                link: UrlsConfig.MAIN,
            },
        },
        notFound: {
            errorCode: "404",
            title: t("error:notFoundErrorTitle"),
            subtitle: t("error:notFoundErrorSubtitle"),
            image,
            button: {
                text: t("error:notFoundCTAText"),
                link: UrlsConfig.MAIN,
            },
        },
        referral: {
            errorCode: "404",
            title: t("error:referralErrorTitle"),
            subtitle: t("error:referralErrorDescription"),
            image,
            button: {
                text: t("error:referralCTAText"),
                link: UrlsConfig.MAIN,
            },
        },
        advocate: {
            errorCode: "404",
            title: t("error:advocateErrorTitle"),
            subtitle: t("error:advocateErrorDescription"),
            image,
            button: {
                text: t("error:advocateCTAText"),
                link: UrlsConfig.MAIN,
            },
        },
    };
};

export default pageContent;
